import {useGetContactInfo} from "../../api/common/useGetContactInfo";
import {useKeycloak} from "../../providers/KeycloakProvider";


export const useIsAdvisor = () => {
  const {linkedContact} = useKeycloak();
  // Only care about the linked contact and not the selected contact.
  const {data} = useGetContactInfo(true, linkedContact);
  // 4 is the Asset Manager contact type
  return data?.contactType?.id === 4;
}